export const INFORMACOES_EMPREGADOR = "INFORMACOES_EMPREGADOR";
export const TABELA_ESTABELECIMENTO = "TABELA_ESTABELECIMENTO";
export const TABELA_RUBRICA = "TABELA_RUBRICA";
export const TABELA_LOTACAO = "TABELA_LOTACAO";
export const TABELA_PROCESSO = "TABELA_PROCESSO";
export const ADMISSAO_TRABALHADOR = "ADMISSAO_TRABALHADOR";
export const CESSAO = "CESSAO";
export const ALTERACAO_CADASTRAL = "ALTERACAO_CADASTRAL";
export const ALTERACAO_CONTRATUAL = "ALTERACAO_CONTRATUAL";
export const AFASTAMENTO_TEMPORARIO = "AFASTAMENTO_TEMPORARIO";
export const DESLIGAMENTO = "DESLIGAMENTO";
export const REINTEGRACAO = "REINTEGRACAO";
export const TSV_INICIO = "TSV_INICIO";
export const TSV_ALTERACAO_CONTRATUAL = "TSV_ALTERACAO_CONTRATUAL";
export const TSV_TERMINO = "TSV_TERMINO";
export const CADASTRO_BENEFICIARIO_INI = "CADASTRO_BENEFICIARIO_INI";
export const CADASTRO_BENEFICIARIO_ALT = "CADASTRO_BENEFICIARIO_ALT";
export const CADASTRO_BENEFICIO_INI = "CADASTRO_BENEFICIO_INI";
export const CADASTRO_BENEFICIO_ALT = "CADASTRO_BENEFICIO_ALT";
export const CADASTRO_BENEFICIO_TERM = "CADASTRO_BENEFICIO_TERM";
export const REATIVACAO_BENEFICIO = "REATIVACAO_BENEFICIO";
export const REMUNERACAO_RGPS = "REMUNERACAO_RGPS";
export const REMUNERACAO_RPPS = "REMUNERACAO_RPPS";
export const BENEFICIO_RPPS = "BENEFICIO_RPPS";
export const PAGAMENTOS = "PAGAMENTOS";
export const REABERTURA_PERIODICOS = "REABERTURA_PERIODICOS";
export const FECHAMENTO_PERIODICOS = "FECHAMENTO_PERIODICOS";
export const EXCLUSAO = "EXCLUSAO";
export const EXP_RISCO = "EXP_RISCO";
export const CAT = "CAT";
export const MONIT = "MONIT";
